
import React, { useState, useEffect } from "react";


import { Modal, Spinner, Container, Button } from "react-bootstrap";
import Menu from "../../CONTAINERS/menu/menu";
import Footer from "../../CONTAINERS/footer/footer";

import moment from "moment";
import "moment/locale/es";
import es_ES from "antd/lib/locale/es_ES";

import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
// eslint-disable-next-line
import filterFactory, {
  textFilter,
} from "react-bootstrap-table2-filter";
import ToolkitProvider, {
  ColumnToggle,
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";

import {
  Space,
  ConfigProvider,
  Input,
  Col,
  Row, Select
} from "antd";



import { SearchOutlined } from "@ant-design/icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExcel,
  faRepeat,
  faSearch,
  faCircleXmark,
  faCircleCheck,
  faTableColumns,
  faPersonMilitaryPointing,
  faList,
  faMapLocationDot,
  faSquareCheck,
  faSquareXmark,
  faLocationCrosshairs,
  faCrosshairs
} from "@fortawesome/free-solid-svg-icons";


import ConsultaNochero from "../../API/MICROSERVICES/NOCHERO/Nocheto";
import ConsultaTopDesk from "../../API/MICROSERVICES/ConsultaTopDesk/ConsultaTopDesk";
import AlertaCentral from "../../SHARED/CentralAlertas";
import EncargoRuteo from "../../API/MICROSERVICES/ENCARGO_RUTEO/EncargoRuteo";
import SubMenu from "../../CONTAINERS/subMenu/subMenu";
import PlanificadorRuta from "../../API/MICROSERVICES/PLANIFICADOR_RUTA/PlanificadorRuta";
import RuteoWeb from "../../API/MICROSERVICES/RUTE_WEB/RuteoWeb";


export default function GARITA(props: any) {

  const axios = require('axios');

  const { history } = props; // para los cambios de pagina

  const [datosSinFiltro, setDatosSinFiltro] = useState();


  const [fechaActual, setFechaActual] = useState("");
  const [fech, setFetch] = useState("");
  const [idProceso, setIdProceso] = useState("");
  const [idDataBase, setIdDataBase] = useState("");


  const [showU, setShowU] = useState(false); // variable para modal

  const [showConfirmacion, setShowConfirmacion] = useState(false);              // variable para Modal Cta
  const handleCloseConfirmacion = () => setShowConfirmacion(false);


  const [showConfirmacionMulti, setShowConfirmacionMulti] = useState(false);              // variable para Modal Cta
  const handleCloseConfirmacionMulti = () => setShowConfirmacionMulti(false);


  const [showInformacion, setShowInformacion] = useState(false);              // variable para Modal Cta
  const handleCloseInformacion = () => setShowInformacion(false);

  const [infoidproceso, setInfoidProceso] = useState("");
  const [infoqueryproceso, setInfoqueryproceso] = useState("");


  const [buttonStatusNochero, setButtonStatusNochero] = useState(false);
  const [buttonStatusConsultaTDKprd, setButtonStatusConsultaTDKprd] = useState(false);
  const [buttonStatusConsultaTDKqa, setButtonStatusConsultaTDKqa] = useState(false);


  const [buttonStatusPlanificadoRutaprd, setButtonStatusPlanificadoRutaprd] = useState(false);
  const [buttonStatusPlanificadoRutaqa, setButtonStatusPlanificadoRutaqa] = useState(false);

  const [buttonStatusPlanificadoRutaDBprd, setButtonStatusPlanificadoRutaDBprd] = useState(false);
  const [buttonStatusPlanificadoRutaDBqa, setButtonStatusPlanificadoRutaDBqa] = useState(false);


  const [buttonStatusEncargoRuteoprd, setButtonStatusEncargoRuteoprd] = useState(false);
  const [buttonStatusEncargoRuteoqa, setButtonStatusEncargoRuteoqa] = useState(false);

  const [buttonStatusEncargoRuteoDBprd, setButtonStatusEncargoRuteoDBprd] = useState(false);
  const [buttonStatusEncargoRuteoDBqa, setButtonStatusEncargoRuteoDBqa] = useState(false);

  const { ExportCSVButton } = CSVExport;

  // eslint-disable-next-line
  const { ToggleList } = ColumnToggle;

  const { SearchBar } = Search;

  const [info, setInfo] = useState([] as any[]);

  // @ts-ignore
  const CustomToggleList = ({ columns, onColumnToggle, toggles }) => (
    <div className="btn-group btn-group-toggle " data-toggle="buttons">
      {columns
        .map((column: any) => ({
          ...column,
          toggle: toggles[column.dataField],
        }))
        .map((column: any) => (
          <button
            type="button"
            key={column.dataField}
            className={`btn-sm btn btn-outline-primary text-sm-center ${column.toggle ? "active" : ""
              }`}
            data-toggle="button"
            aria-pressed={column.toggle ? "true" : "false"}
            onClick={() => onColumnToggle(column.dataField)}
            style={{ fontSize: "11px" }}
          >
            {column.text}
          </button>
        ))}
    </div>
  );


  function ordenaDatos(jerons: any) {

    setDatosSinFiltro(jerons);

    setInfo(jerons);

    setShowU(false);
    TABLA(info, columns);
  }

  //===================================================================================================================
  // seteo de Columnas a mostrar en el DAta Table
  const columns = [
    {
      dataField: "Id",
      text: "ID",
      sort: true,
      filter: textFilter(),
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "User",
      text: "Usuario",
      sort: true,
      filter: textFilter(),
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "Host",
      text: "Host",
      sort: true,
      filter: textFilter(),
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "Db",
      text: "Base de Datos",
      sort: true,
      filter: textFilter(),
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "Command",
      text: "Comando",
      sort: true,
      filter: textFilter(),
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "Time",
      text: "Tiempo",
      sort: true,
      filter: textFilter(),
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "State",
      text: "Estado",
      sort: true,
      filter: textFilter(),
      headerAlign: "center",
      align: "center",
    },

    {
      dataField: "Info",
      text: "Informacion",
      sort: true,
      filter: textFilter(),
      headerAlign: "center",
      align: "center",
    }
  ];


  const options = {
    // paginationSize: 5,
    // pageStartIndex: 0,
    // // alwaysShowAllBtns: true, // Always show next and previous button
    // // withFirstAndLast: false, // Hide the going to First and Last page button
    // // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: 'Primera',
    prePageText: 'Atrás',
    nextPageText: 'Siguiente',
    lastPageText: 'Última',
    nextPageTitle: 'Primeta Página',
    prePageTitle: 'Página Anterior',
    firstPageTitle: 'Próxima Página',
    lastPageTitle: 'Última Página',
    showTotal: true,
    // disablePageTitle: true,

  };

  //Construye la tabla con 2 parametos
  // ELEMENTO GRAFICO DE LA TABLA
  // @ts-ignore
  const TABLA = (json: any, col: any) => {
    return (
      <>
        <ToolkitProvider
          bootstrap4
          keyField="ID"
          data={json}
          columns={col}
          columnToggle
          exportCSV={{
            fileName: "Datos_Garita.csv",
            noAutoBOM: false,
            onlyExportFiltered: true,
            exportAll: false,
          }}
          search
        >
          {(props) => (
            <div>
              <div>
                <div className="row">
                  <div className="col"></div>
                  <div className="col text-end">
                    <button className="btn btn-primary shadow disabled">
                      <label>Búqueda General</label>{" "}
                      <FontAwesomeIcon icon={faSearch} />{" "}
                    </button>

                  </div>
                  <div className="col">
                    <SearchBar
                      {...props.searchProps}
                      style={{
                        width: "300px",
                        float: "right",
                        marginBottom: "2rem",
                      }}
                      placeholder="Busca en todos los campos de la tabla"
                    />


                  </div>


                </div>
              </div>


              <CustomToggleList {...props.columnToggleProps} />

              <hr style={{ color: "blue" }} />

              <BootstrapTable
                {...props.baseProps}
                bootstrap4
                hover
                keyField="Id"
                columns={col}
                data={json}
                noDataIndication="Disculpa, no logramos encontrar datos :("
                filter={filterFactory()}
                pagination={paginationFactory(options)}

              />
              <hr style={{ color: "blue" }} />
              <Space>
                <ExportCSVButton
                  {...props.csvProps}
                  className=" btn btn-primary shadow "
                >
                  <FontAwesomeIcon icon={faFileExcel} /> Exportar CSV{" "}
                </ExportCSVButton>
                <label>
                  {" "}
                  * Se Exporta el <b> CSV filtrado. </b>{" "}
                </label>
              </Space>
            </div>
          )}
        </ToolkitProvider>
      </>
    );
  }; //


  const { TextArea } = Input;

  async function cargaStatus() {

    setShowU(true);


    let fechaActual: Date = new Date(); // se obtiene la fecha actual

    let fechaFormateada = moment(fechaActual).format("DD-MM-YYYY"); // se formatea la fecha actual

    let horaFormateada = moment(fechaActual).format("hh:mm:ss");

    setFetch(horaFormateada); // se setea la fecha formateada
    setFechaActual(fechaFormateada); // se manda la fecha para los calculos logicos


    let response = await ConsultaNochero.ShowNow().then((resp) => {
      return resp;
    });


    if (response.status === 200) {
      setButtonStatusNochero(true);
    } else {
      setButtonStatusNochero(false);
    }



    let response_detalle_PRD = await validaConsultaTDk_PRD();


    if (response_detalle_PRD.status === 200) {
      setButtonStatusConsultaTDKprd(true);
    } else {
      setButtonStatusConsultaTDKprd(false);
    }



    let response_detalle_QA = await validaConsultaTDk_QA();


    if (response_detalle_QA.status !== -1) {
      setButtonStatusConsultaTDKqa(true);
    } else {
      setButtonStatusConsultaTDKqa(false);
    }



    let response_encargo_ruteo_PR = await ValidarEncargoRuteo_PRD();


    if (response_encargo_ruteo_PR.status === 200) {
      setButtonStatusEncargoRuteoprd(true);
    } else {
      setButtonStatusEncargoRuteoprd(false);
    }



    let response_encargo_ruteo_QA = await ValidarEncargoRuteo_QA();


    if (response_encargo_ruteo_QA.status === 200) {
      setButtonStatusEncargoRuteoqa(true);
    } else {
      setButtonStatusEncargoRuteoqa(false);
    }

    let response_encargo_ruteo_DB_PRD = await ValidarEncargoRuteo_DB_PRD();

    if (response_encargo_ruteo_DB_PRD.status === 200) {
      setButtonStatusEncargoRuteoDBprd(true);
    } else {
      setButtonStatusEncargoRuteoDBprd(false);
    }


    let response_encargo_ruteo_DB_QA = await ValidarEncargoRuteo_DB_QA();


    if (response_encargo_ruteo_DB_QA.status === 200) {
      setButtonStatusEncargoRuteoDBqa(true);
    } else {
      setButtonStatusEncargoRuteoDBqa(false);
    }


    let response_planificador_ruta_PRD = await ValidarPlanificadorRuta_PRD();

    if (response_planificador_ruta_PRD.status === 200) {
      setButtonStatusPlanificadoRutaprd(true);
    } else {
      setButtonStatusPlanificadoRutaprd(false);
    }

    let response_planificador_ruta_QA = await ValidarPlanificadorRuta_QA();


    if (response_planificador_ruta_QA.status === 200) {
      setButtonStatusPlanificadoRutaqa(true);
    } else {
      setButtonStatusPlanificadoRutaqa(false);
    }


    let response_planificador_ruta_DB_PRD = await ValidarPlanificadorRuta_PRD();

    if (response_planificador_ruta_DB_PRD.status === 200) {
      setButtonStatusPlanificadoRutaDBprd(true);
    } else {
      setButtonStatusPlanificadoRutaDBprd(false);
    }

    let response_planificador_ruta_DB_QA = await ValidarPlanificadorRuta_QA();


    if (response_planificador_ruta_DB_QA.status === 200) {
      setButtonStatusPlanificadoRutaDBqa(true);
    } else {
      setButtonStatusPlanificadoRutaDBqa(false);
    }



    setShowU(false);
  }

  async function CargaShowProcessList() {

    setShowU(true);

    let fechaActual: Date = new Date(); // se obtiene la fecha actual

    let fechaFormateada = moment(fechaActual).format("DD-MM-YYYY"); // se formatea la fecha actual

    let horaFormateada = moment(fechaActual).format("hh:mm:ss");

    setFetch(horaFormateada); // se setea la fecha formateada
    setFechaActual(fechaFormateada); // se manda la fecha para los calculos logicos



    let arrayVacio: any[] = [];
    setInfo(arrayVacio);

    let response = await ConsultaNochero.ShowNow().then((resp) => {
      return resp;
    });


    let datos = response.data.mensaje;

    let arrayDatos: any[] = datos.split("), (");
    let ArrayResult: any[] = [];

    arrayDatos.forEach((dato: any) => {

      let datolargo = dato.split(", ");

      let Query: any;

      let arrayalgo: any[] = [];

      if (datolargo.length > 6) {
        datolargo.forEach((el: any, index: number) => {
          if (index > 6) {
            arrayalgo.push(el);
          }
        });

        Query = arrayalgo.reduce((acc, current) => acc + ' ' + current, '');
      }

      let datonew = dato.replace("((", "");
      let datonew02 = datonew.replace("))", "");

      let arrdat: any[] = datonew02.split(", ");

      let buton;

      if (Query.trim() != "None") {

        buton = <Button size="sm" onClick={() => { cargarModalInformacion(Query.trim(), arrdat[0]) }}> {" "} Detalle {" "} &nbsp;
          <FontAwesomeIcon style={{ fontSize: "10px" }} icon={faSquareCheck} />
        </Button>;

      } else {
        buton = <Button size="sm" disabled>  {" "} Detalle {" "} &nbsp;
          <FontAwesomeIcon style={{ fontSize: "10px" }} icon={faSquareXmark} />
        </Button>;

      }


      let obj = {
        Id: arrdat[0],
        User: arrdat[1],
        Host: arrdat[2],
        Db: arrdat[3],
        Command: arrdat[4],
        Time: arrdat[5],
        State: arrdat[6],
        Info: buton,
      }



      if (obj.User !== "'rdsrepladmin'") {
        if (obj.User !== "'rdsadmin'") {
          ArrayResult.push(obj)
        }
      }


    });

    ordenaDatos(ArrayResult);

    setShowU(false);

  }


  async function cargarModalInformacion(query: any, idproceso: any) {




    setInfoidProceso(idproceso);
    setInfoqueryproceso(query);

    setShowInformacion(true);

  }

  async function validaConsultaTDk_QA() {

    let data = JSON.stringify({
      "odflcodigo": 959269219
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://topdesk-consultaqa.starken.cl/TopDeskConsulta/tracking/AgregadoDetalle',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Basic dGRrX3BydWViYTp0ZGsyMDIz'
      },
      data: data
    };

    let resp = await axios.request(config)
      .then((response: any) => {
        return response;
      })
      .catch((error: any) => {
        return error;
      });


    return resp;

  }

  async function validaConsultaTDk_PRD() {

    let data = JSON.stringify({
      "odflcodigo": 959269219
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://topdesk-consulta.starken.cl/TopDeskConsulta/tracking/AgregadoDetalle',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Basic dGRrOnRkazIwMjE='
      },
      data: data
    };



    let resp = await axios.request(config)
      .then((response: any) => {
        return response;
      })
      .catch((error: any) => {
        return error;
      });




    return resp;

  }

  async function ValidarEncargoRuteo_PRD() {

    return EncargoRuteo.getPingPRD().then((resp) => {
      return resp;
    })

  }

  async function ValidarEncargoRuteo_QA() {

    return EncargoRuteo.getPingQA().then((resp) => {

      return resp;
    })


  }

  async function ValidarEncargoRuteo_DB_PRD() {

    return EncargoRuteo.getPingOraclePRD().then((resp) => {
      return resp;
    })

  }

  async function ValidarEncargoRuteo_DB_QA() {

    return EncargoRuteo.getPingOracleQA().then((resp) => {

      return resp;
    })


  }

  async function ValidarPlanificadorRuta_PRD() {

    return PlanificadorRuta.getPRD().then((resp) => {
      return resp;
    })

  }

  async function ValidarPlanificadorRuta_QA() {

    return PlanificadorRuta.getQA().then((resp) => {
      return resp;
    })

  }



  async function matarProceso(idproceso: any) {


    let id = idproceso;

    try {


      let respuesta = await ConsultaNochero.KillNow(id).then((resp) => {
        return resp.data;
      });

      if (respuesta.statusCode === 200) {

        AlertaCentral("PROCESOELIMINADOOK", "", "", respuesta.mensaje);
        setShowConfirmacion(false);

      } else {
        AlertaCentral("ERRORELIMINADOPROCESO", "", "", respuesta.mensaje);
      }

    } catch (e) {

      AlertaCentral("INDETERMINADO");

    }

  }

  async function matarMultiProceso(dbname: any) {

    let DBNAME = dbname;

    try {


      let respuesta = await ConsultaNochero.MultiKillNow(DBNAME).then((resp) => {
        return resp.data;
      });

      if (respuesta.statusCode === 200) {

        AlertaCentral("PROCESOELIMINADOOK", "", "", respuesta.mensaje);
        setShowConfirmacionMulti(false);

      } else {
        AlertaCentral("ERRORELIMINADOPROCESO", "", "", respuesta.mensaje);
      }

    } catch (e) {
      AlertaCentral("INDETERMINADO");
    }

  }


  useEffect(() => {
    cargaStatus();
    CargaShowProcessList();
  }, []);


  return (
    <>
      <ConfigProvider locale={es_ES}>
        <Menu titulo="Garita MyStarken" logo="" />



        <Container className="justify-content-center rounded mt-5" style={{ background: "white" }}>

          {/* PRIMER NIVEL */}
          <ul className="nav nav-tabs" id="principal" role="tablist">
            <li className="nav-item" role="presentation">
              <button className="nav-link active mt-2" id="dashboars-tab" data-bs-toggle="tab" data-bs-target="#dashboar-tab-pane" type="button" role="tab" aria-controls="dashboars-tab-pane" aria-selected="true">
                <FontAwesomeIcon icon={faTableColumns} /> &nbsp;
                DashBoard's
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button className="nav-link  mt-2" id="nochero-tab" data-bs-toggle="tab" data-bs-target="#nochero-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="false">
                <FontAwesomeIcon icon={faPersonMilitaryPointing} /> &nbsp;
                Api Nochero
              </button>
            </li>
          </ul>

          {/* CONTENIDO PRIMER NIVEL */}
          <div className="tab-content" id="principalContent">

            {/* DASHBOARDS */}
            <div className="tab-pane fade show active" id="dashboar-tab-pane" role="tabpanel" aria-labelledby="dashboars-tab">
              <Container>
                {/* SEGUNDO NIVEL  */}
                <ul className="nav nav-tabs" id="dashboards" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button className="nav-link active mt-2" id="general-tab" data-bs-toggle="tab" data-bs-target="#general-tab-pane" type="button" role="tab" aria-controls="general-tab-pane" aria-selected="true">
                      <FontAwesomeIcon icon={faList} /> &nbsp;
                      General
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button className="nav-link  mt-2" id="planificador-tab" data-bs-toggle="tab" data-bs-target="#planificador-tab-pane" type="button" role="tab" aria-controls="planificador-tab-pane" aria-selected="true">
                      <FontAwesomeIcon icon={faMapLocationDot} /> &nbsp;
                      Planificador de Ruta
                    </button>
                  </li>
                </ul>
                {/* CONTENIDO SEGUNDO NIVEL */}
                <div className="tab-content" id="dashboardsContent">
                  <div className="tab-pane fade show active" id="general-tab-pane" role="tabpanel" aria-labelledby="general-tab">
                    <Container className="mt-3">
                      <Row>

                        <Col className="col-4">
                          <Button
                            onClick={cargaStatus}
                          >
                            <FontAwesomeIcon icon={faRepeat} />
                            {" "} Recargar {" "}
                          </Button>
                        </Col>
                        <Col className="col-4">
                          <h4> Fecha : {fechaActual} </h4>
                        </Col>

                        <Col className="col-4">
                          <h4>  Hora : {fech}  </h4>
                        </Col>

                      </Row>
                    </Container>
                    <hr style={{ color: "blue" }} />
                    <Container className="mt-3">

                      <Container className="mt-3" >
                        <Row>
                          <Col className="col-3 mt-2"> <h4> <b> Nombre Recurso </b> </h4> </Col>
                          <Col className="col-3 mt-2"> <h4> <b> Status </b> </h4> </Col>
                          <Col className="col-3 mt-2"> <h4> <b> Link </b> </h4> </Col>

                        </Row>
                        <Row className="mb-5">
                          <Col className="col-3 mt-2"> <h5> Api Nochero </h5></Col>
                          <Col className="col-3">

                            {buttonStatusNochero ? (<>
                              <Button variant="success" disabled > On-Line {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleCheck} />
                              </Button>

                            </>) : (<>
                              <Button variant="danger" disabled> Off-Line  {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleXmark} />
                              </Button>
                            </>)}
                          </Col>
                          <Col className="col-3"> <label> https://supervisor.mystarken.cl/docs </label>  </Col>
                        </Row>

                        <hr style={{ color: "blue" }} />

                        <Row className="mb-5">
                          <Col className="col-3 mt-2"> <h5> Api Consulta Topdesk PRD </h5></Col>
                          <Col className="col-3">

                            {buttonStatusConsultaTDKprd ? (<>
                              <Button variant="success" disabled > On-Line {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleCheck} />
                              </Button>

                            </>) : (<>
                              <Button variant="danger" disabled> Off-Line  {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleXmark} />
                              </Button>
                            </>)}
                          </Col>
                          <Col className="col-3"> <label> https://topdesk-consulta.starken.cl/TopDeskConsulta/swagger-ui.html</label>  </Col>
                        </Row>

                        <Row className="mb-5">
                          <Col className="col-3 mt-2"> <h5> Api Consulta Topdesl QA </h5></Col>
                          <Col className="col-3">

                            {buttonStatusConsultaTDKqa ? (<>
                              <Button variant="success" disabled > On-Line {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleCheck} />
                              </Button>

                            </>) : (<>
                              <Button variant="danger" disabled> Off-Line  {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleXmark} />
                              </Button>
                            </>)}
                          </Col>
                          <Col className="col-3"> <label> https://topdesk-consultaqa.starken.cl/TopDeskConsulta/swagger-ui.html</label>  </Col>
                        </Row>

                        <hr style={{ color: "blue" }} />

                        <Row className="mb-5">
                          <Col className="col-3 mt-2"> <h5> Api Encargo Ruteo PRD </h5></Col>
                          <Col className="col-3">

                            {buttonStatusEncargoRuteoprd ? (<>
                              <Button variant="success" disabled > On-Line {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleCheck} />
                              </Button>

                            </>) : (<>
                              <Button variant="danger" disabled> Off-Line  {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleXmark} />
                              </Button>
                            </>)}
                          </Col>
                          <Col className="col-3"> <label> https://myservice.starken.cl/EncargoRuteo/swagger-ui.html</label>  </Col>
                        </Row>

                        <Row className="mb-5">
                          <Col className="col-3 mt-2"> <h5>Api Encargo Ruteo QA </h5></Col>
                          <Col className="col-3">

                            {buttonStatusEncargoRuteoqa ? (<>
                              <Button variant="success" disabled > On-Line {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleCheck} />
                              </Button>

                            </>) : (<>
                              <Button variant="danger" disabled> Off-Line  {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleXmark} />
                              </Button>
                            </>)}
                          </Col>
                          <Col className="col-3"> <label> https://myserviceqa.starken.cl/EncargoRuteo/swagger-ui.html</label>  </Col>
                        </Row>


                        <hr style={{ color: "blue" }} />

                        <Row className="mb-5">
                          <Col className="col-3 mt-2"> <h5> Api Encargo Ruteo DB  PRD </h5></Col>
                          <Col className="col-3">

                            {buttonStatusEncargoRuteoDBprd ? (<>
                              <Button variant="success" disabled > On-Line {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleCheck} />
                              </Button>

                            </>) : (<>
                              <Button variant="danger" disabled> Off-Line  {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleXmark} />
                              </Button>
                            </>)}
                          </Col>
                          <Col className="col-3"> <label> https://myservice.starken.cl/EncargoRuteo/swagger-ui.html</label>  </Col>
                        </Row>

                        <Row className="mb-5">
                          <Col className="col-3 mt-2"> <h5>Api Encargo Ruteo DB  QA </h5></Col>
                          <Col className="col-3">

                            {buttonStatusEncargoRuteoDBqa ? (<>
                              <Button variant="success" disabled > On-Line {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleCheck} />
                              </Button>

                            </>) : (<>
                              <Button variant="danger" disabled> Off-Line  {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleXmark} />
                              </Button>
                            </>)}
                          </Col>
                          <Col className="col-3"> <label> https://myserviceqa.starken.cl/EncargoRuteo/swagger-ui.html</label>  </Col>
                        </Row>

                        <hr style={{ color: "blue" }} />

                        <Row className="mb-5">
                          <Col className="col-3 mt-2"> <h5> Api Planificador Ruta PRD </h5></Col>
                          <Col className="col-3">

                            {buttonStatusPlanificadoRutaprd ? (<>
                              <Button variant="success" disabled > On-Line {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleCheck} />
                              </Button>

                            </>) : (<>
                              <Button variant="danger" disabled> Off-Line  {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleXmark} />
                              </Button>
                            </>)}
                          </Col>
                          <Col className="col-3"> <label> https://myservice.starken.cl/planificadorRuta/swagger-ui.html</label>  </Col>
                        </Row>

                        <Row className="mb-5">
                          <Col className="col-3 mt-2"> <h5>Api Planificador Ruta QA </h5></Col>
                          <Col className="col-3">

                            {buttonStatusPlanificadoRutaqa ? (<>
                              <Button variant="success" disabled > On-Line {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleCheck} />
                              </Button>

                            </>) : (<>
                              <Button variant="danger" disabled> Off-Line  {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleXmark} />
                              </Button>
                            </>)}
                          </Col>
                          <Col className="col-3"> <label> https://myserviceqa.starken.cl/planificadorRuta/swagger-ui.html </label> </Col>
                        </Row>

                        <hr style={{ color: "blue" }} />

                        <Row className="mb-5">
                          <Col className="col-3 mt-2"> <h5> Api Planificador Ruta DB PRD </h5></Col>
                          <Col className="col-3">

                            {buttonStatusPlanificadoRutaDBprd ? (<>
                              <Button variant="success" disabled > On-Line {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleCheck} />
                              </Button>

                            </>) : (<>
                              <Button variant="danger" disabled> Off-Line  {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleXmark} />
                              </Button>
                            </>)}
                          </Col>
                          <Col className="col-3"> <label> https://myservice.starken.cl/planificadorRuta/swagger-ui.html</label>  </Col>
                        </Row>

                        <Row className="mb-5">
                          <Col className="col-3 mt-2"> <h5>Api Planificador Ruta DB QA </h5></Col>
                          <Col className="col-3">

                            {buttonStatusPlanificadoRutaDBqa ? (<>
                              <Button variant="success" disabled > On-Line {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleCheck} />
                              </Button>

                            </>) : (<>
                              <Button variant="danger" disabled> Off-Line  {" "} &nbsp;
                                <FontAwesomeIcon icon={faCircleXmark} />
                              </Button>
                            </>)}
                          </Col>
                          <Col className="col-3"> <label> https://myserviceqa.starken.cl/planificadorRuta/swagger-ui.html </label> </Col>
                        </Row>



                      </Container>

                      <hr style={{ color: "blue" }} />


                    </Container>

                  </div>

                  <div className="tab-pane fade show" id="planificador-tab-pane" role="tabpanel" aria-labelledby="planificador-tab">
                    <Container className="mt-3">
                      <Row>

                        <Col className="col-4">
                          <Button
                            onClick={cargaStatus}
                          >
                            <FontAwesomeIcon icon={faRepeat} />
                            {" "} Recargar {" "}
                          </Button>
                        </Col>
                        <Col className="col-4">
                          <h4> Fecha : {fechaActual} </h4>
                        </Col>

                        <Col className="col-4">
                          <h4>  Hora : {fech}  </h4>
                        </Col>

                      </Row>
                    </Container>
                    <hr style={{ color: "blue" }} />

                    <hr style={{ color: "blue" }} />

                    <Row className="mb-5">
                      <Col className="col-3 mt-2"> <h5> Api Encargo Ruteo PRD </h5></Col>
                      <Col className="col-3">

                        {buttonStatusEncargoRuteoprd ? (<>
                          <Button variant="success" disabled > On-Line {" "} &nbsp;
                            <FontAwesomeIcon icon={faCircleCheck} />
                          </Button>

                        </>) : (<>
                          <Button variant="danger" disabled> Off-Line  {" "} &nbsp;
                            <FontAwesomeIcon icon={faCircleXmark} />
                          </Button>
                        </>)}
                      </Col>
                      <Col className="col-3"> <label> https://myservice.starken.cl/EncargoRuteo/swagger-ui.html</label>  </Col>
                    </Row>

                    <Row className="mb-5">
                      <Col className="col-3 mt-2"> <h5>Api Encargo Ruteo QA </h5></Col>
                      <Col className="col-3">

                        {buttonStatusEncargoRuteoqa ? (<>
                          <Button variant="success" disabled > On-Line {" "} &nbsp;
                            <FontAwesomeIcon icon={faCircleCheck} />
                          </Button>

                        </>) : (<>
                          <Button variant="danger" disabled> Off-Line  {" "} &nbsp;
                            <FontAwesomeIcon icon={faCircleXmark} />
                          </Button>
                        </>)}
                      </Col>
                      <Col className="col-3"> <label> https://myserviceqa.starken.cl/EncargoRuteo/swagger-ui.html</label>  </Col>
                    </Row>


                    <hr style={{ color: "blue" }} />

                    <Row className="mb-5">
                      <Col className="col-3 mt-2"> <h5> Api Encargo Ruteo DB  PRD </h5></Col>
                      <Col className="col-3">

                        {buttonStatusEncargoRuteoDBprd ? (<>
                          <Button variant="success" disabled > On-Line {" "} &nbsp;
                            <FontAwesomeIcon icon={faCircleCheck} />
                          </Button>

                        </>) : (<>
                          <Button variant="danger" disabled> Off-Line  {" "} &nbsp;
                            <FontAwesomeIcon icon={faCircleXmark} />
                          </Button>
                        </>)}
                      </Col>
                      <Col className="col-3"> <label> https://myservice.starken.cl/EncargoRuteo/swagger-ui.html</label>  </Col>
                    </Row>

                    <Row className="mb-5">
                      <Col className="col-3 mt-2"> <h5>Api Encargo Ruteo DB  QA </h5></Col>
                      <Col className="col-3">

                        {buttonStatusEncargoRuteoDBqa ? (<>
                          <Button variant="success" disabled > On-Line {" "} &nbsp;
                            <FontAwesomeIcon icon={faCircleCheck} />
                          </Button>

                        </>) : (<>
                          <Button variant="danger" disabled> Off-Line  {" "} &nbsp;
                            <FontAwesomeIcon icon={faCircleXmark} />
                          </Button>
                        </>)}
                      </Col>
                      <Col className="col-3"> <label> https://myserviceqa.starken.cl/EncargoRuteo/swagger-ui.html</label>  </Col>
                    </Row>

                    <hr style={{ color: "blue" }} />

                    <Row className="mb-5">
                      <Col className="col-3 mt-2"> <h5> Api Planificador Ruta PRD </h5></Col>
                      <Col className="col-3">

                        {buttonStatusPlanificadoRutaprd ? (<>
                          <Button variant="success" disabled > On-Line {" "} &nbsp;
                            <FontAwesomeIcon icon={faCircleCheck} />
                          </Button>

                        </>) : (<>
                          <Button variant="danger" disabled> Off-Line  {" "} &nbsp;
                            <FontAwesomeIcon icon={faCircleXmark} />
                          </Button>
                        </>)}
                      </Col>
                      <Col className="col-3"> <label> https://myservice.starken.cl/planificadorRuta/swagger-ui.html</label>  </Col>
                    </Row>

                    <Row className="mb-5">
                      <Col className="col-3 mt-2"> <h5>Api Planificador Ruta QA </h5></Col>
                      <Col className="col-3">

                        {buttonStatusPlanificadoRutaqa ? (<>
                          <Button variant="success" disabled > On-Line {" "} &nbsp;
                            <FontAwesomeIcon icon={faCircleCheck} />
                          </Button>

                        </>) : (<>
                          <Button variant="danger" disabled> Off-Line  {" "} &nbsp;
                            <FontAwesomeIcon icon={faCircleXmark} />
                          </Button>
                        </>)}
                      </Col>
                      <Col className="col-3"> <label> https://myserviceqa.starken.cl/planificadorRuta/swagger-ui.html </label> </Col>
                    </Row>

                    <hr style={{ color: "blue" }} />

                    <Row className="mb-5">
                      <Col className="col-3 mt-2"> <h5> Api Planificador Ruta DB PRD </h5></Col>
                      <Col className="col-3">

                        {buttonStatusPlanificadoRutaDBprd ? (<>
                          <Button variant="success" disabled > On-Line {" "} &nbsp;
                            <FontAwesomeIcon icon={faCircleCheck} />
                          </Button>

                        </>) : (<>
                          <Button variant="danger" disabled> Off-Line  {" "} &nbsp;
                            <FontAwesomeIcon icon={faCircleXmark} />
                          </Button>
                        </>)}
                      </Col>
                      <Col className="col-3"> <label> https://myservice.starken.cl/planificadorRuta/swagger-ui.html</label>  </Col>
                    </Row>

                    <Row className="mb-5">
                      <Col className="col-3 mt-2"> <h5>Api Planificador Ruta DB QA </h5></Col>
                      <Col className="col-3">

                        {buttonStatusPlanificadoRutaDBqa ? (<>
                          <Button variant="success" disabled > On-Line {" "} &nbsp;
                            <FontAwesomeIcon icon={faCircleCheck} />
                          </Button>

                        </>) : (<>
                          <Button variant="danger" disabled> Off-Line  {" "} &nbsp;
                            <FontAwesomeIcon icon={faCircleXmark} />
                          </Button>
                        </>)}
                      </Col>
                      <Col className="col-3"> <label> https://myserviceqa.starken.cl/planificadorRuta/swagger-ui.html </label> </Col>
                    </Row>

                  </div>
                  {/* FIN CONTENIDO SEGUNDO NIVEL */}
                </div>
              </Container>
            </div>  {/* PRIMERO */}
            {/* FINAL DASHBOARDS */}

            {/* API NOCHERO  */}
            <div className="tab-pane fade show" id="nochero-tab-pane" role="tabpanel" aria-labelledby="nochero-tab">
              <Container>

                <ul className="nav nav-tabs" id="myTab2" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button className="nav-link active mt-2" id="info-tab" data-bs-toggle="tab" data-bs-target="#info-tab-pane" type="button" role="tab" aria-controls="info-tab-pane" >Información</button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button className="nav-link mt-2" id="accion-tab" data-bs-toggle="tab" data-bs-target="#accion-tab-pane" type="button" role="tab" aria-controls="accion-tab-pane" >Acciones</button>
                  </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                  <div className="tab-pane fade show active" id="info-tab-pane" role="tabpanel" aria-labelledby="info-tab" >
                    <Container className="justify-content-center">

                      <Row className="justify-content-start">
                        <Col className="mt-3">
                          <Button
                            onClick={CargaShowProcessList}
                          >
                            <FontAwesomeIcon icon={faRepeat} />
                            {" "} Recargar {" "}
                          </Button>
                        </Col>

                      </Row>

                      <Row>
                        <Container className="mt-3">
                          <Row className="justify-content-center">

                            <Col className="col-4">
                              <h4> Fecha : {fechaActual} </h4>
                            </Col>

                            <Col className="col-4">
                              <h4>  Hora : {fech}  </h4>
                            </Col>
                          </Row>
                        </Container>
                      </Row>

                      <hr />

                      <Row>
                        <Col>

                          <div
                            className="expended-container mt-5"
                            style={{
                              overflowX: "scroll",
                              whiteSpace: "pre-line",
                              overflowWrap: "break-word",
                            }}
                          >

                            {TABLA(info, columns)}

                          </div>

                        </Col>
                      </Row>

                    </Container>
                  </div>
                  <div className="tab-pane fade show" id="accion-tab-pane" role="tabpanel" aria-labelledby="accion-tab" >
                    <Container className="mt-3">

                      <h3>  KILL  </h3>

                      <Row className="mt-3 mb-3">
                        <Col>

                          <Row className="Col-2">
                            <label><b>Inserte ID Proceso {" "} &nbsp; </b></label>
                          </Row>


                          <Row>
                            <Space.Compact style={{ width: '100%' }}>
                              <Input
                                placeholder="Inserte ID Proceso"
                                type="number"
                                onChange={(e) => { setIdProceso(e.target.value) }}
                              />
                              <Button style={{ width: "360px" }} onClick={() => { setShowConfirmacion(true) }} >  Matar Proceso {" "} &nbsp;

                                <FontAwesomeIcon icon={faLocationCrosshairs} />{" "}
                              </Button>
                            </Space.Compact>

                          </Row>

                        </Col>

                      </Row>

                      <hr style={{ color: "blue" }} />

                    </Container>

                    <Container className="mt-3">
                      <h3> MULTI KILL  </h3>


                      <Row className="mt-3 mb-3">
                        <Col>


                          <Row className="Col-2">
                            <label><b>Inserte Nombre de Base de Datos {" "} &nbsp; </b></label>
                          </Row>
                          <Row>
                            <Space.Compact style={{ width: '100%' }}>
                              <Input placeholder="Insertar Nombre de Base de Datos"
                                type="text"
                                onChange={(e) => { setIdDataBase(e.target.value) }}
                              />
                              <Button style={{ width: "360px" }} onClick={() => { setShowConfirmacionMulti(true) }} >  Matar Todos los Procesos DB {" "} &nbsp;
                                <FontAwesomeIcon icon={faCrosshairs} />{" "}
                              </Button>
                            </Space.Compact>

                          </Row>
                        </Col>
                      </Row>

                      <hr style={{ color: "blue" }} />

                    </Container>

                  </div>
                </div>
              </Container>
            </div>

          </div>
        </Container>


        <Footer />

        {/* MODAL LOADING */}

        <Modal
          show={showU}
          // onHide="true"
          size="sm"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Body>
            <div className="container text-center">
              <img
                src="https://4.bp.blogspot.com/-n1BU4eOej24/XQDe_qUTiMI/AAAAAAAAFUk/Un_4u9B4krgLjdnAprhBWGlPPb7aJCoUgCK4BGAYYCw/s640/tenor.gif"
                alt="Intervención Divina"
              />
            </div>
            <hr style={{ color: "blue" }} />
            <div className="container text-center">
              <Spinner
                animation="border"
                role="status"
                variant="success"
                size="sm"
              />
              <Spinner animation="border" role="status" variant="primary" />
            </div>
            <div className="container text-center">
              <h6 style={{ color: "blue" }}>Cargando...</h6>
            </div>
          </Modal.Body>
        </Modal>



        {/* MODAL Comfirmacion kill */}
        <Modal
          show={showConfirmacion}
          onHide={handleCloseConfirmacion}
          size="lg"

          backdrop="static"
          keyboard={false}


        >
          <Modal.Header closeButton>
            <Container style={{ color: "blue" }}>
              <Modal.Title className="text-center"> ID de Proceso a Eliminar : {idProceso} </Modal.Title>
            </Container>
          </Modal.Header>
          <Modal.Body>




            <Container className="container-fluid text-center col-sm-12 ">

              <Container className="rounded border bt-4 pt-3 pb-2 mb-3  shadow">

                <Container className="text-center">
                  <h6 style={{ color: "blue" }}>Al hacer Clic en Aceptar,  se Terminará el proceso.</h6>
                </Container>
                <Col className="text-center">

                  <button className=" btn btn-primary  mt-3 mb-3 shadow" onClick={() => { matarProceso(idProceso); }} >
                    {" "}
                    Aceptar
                    {" "} &nbsp;
                    <FontAwesomeIcon icon={faCircleCheck} />

                  </button>

                </Col>

              </Container>

            </Container>


          </Modal.Body>
          <Modal.Footer>

            <Container className="container-fluid">
              <div className="d-flex justify-content-center">

                <button className=" btn btn-danger shadow " onClick={() => { setShowConfirmacion(false) }} >

                  {" "}
                  Cancelar
                  {" "}
                  <FontAwesomeIcon icon={faCircleXmark} />
                </button>



              </div>
            </Container>

          </Modal.Footer>
        </Modal>



        {/* MODAL Comfirmacion Multikill */}
        <Modal
          show={showConfirmacionMulti}
          onHide={handleCloseConfirmacionMulti}
          size="lg"
          backdrop="static"
          keyboard={false}


        >
          <Modal.Header closeButton>
            <Container style={{ color: "blue" }}>
              <Modal.Title className="text-center"> Nombre de Base de datos a eliminar Procesos : {idDataBase} </Modal.Title>
            </Container>
          </Modal.Header>
          <Modal.Body>

            <Container className="container-fluid text-center col-sm-12 ">

              <Container className="rounded border bt-4 pt-3 pb-2 mb-3  shadow">

                <Container className="text-center">
                  <h6 style={{ color: "blue" }}>Al hacer Clic en Aceptar,  se Terminarán TODOS los procesos de la DB.</h6>
                </Container>
                <Col className="text-center">

                  <button className=" btn btn-primary  mt-3 mb-3 shadow" onClick={() => { matarMultiProceso(idDataBase); }} >
                    {" "}
                    Aceptar
                    {" "} &nbsp;
                    <FontAwesomeIcon icon={faCircleCheck} />

                  </button>

                </Col>

              </Container>

            </Container>


          </Modal.Body>
          <Modal.Footer>

            <Container className="container-fluid">
              <div className="d-flex justify-content-center">

                <button className=" btn btn-danger shadow " onClick={() => { setShowConfirmacion(false) }} >

                  {" "}
                  Cancelar
                  {" "}
                  <FontAwesomeIcon icon={faCircleXmark} />
                </button>



              </div>
            </Container>

          </Modal.Footer>
        </Modal>


        {/* MODAL VALOR INFORMACION  */}
        <Modal
          show={showInformacion}
          onHide={handleCloseInformacion}
          size="lg"

          backdrop="static"
          keyboard={false}


        >
          <Modal.Header closeButton>
            <Container style={{ color: "blue" }}>
              <Modal.Title className="text-center"> ID de Proceso : {infoidproceso} </Modal.Title>
            </Container>
          </Modal.Header>
          <Modal.Body>


            <Container className="container-fluid text-center col-sm-12 ">

              <Container className="rounded border bt-4 pt-3 pb-2 mb-3  shadow">

                <Container className="text-center">
                  <h6 style={{ color: "blue" }}>Query de proceso</h6>



                  <TextArea

                    value={infoqueryproceso}
                    placeholder="Controlled autosize"
                    autoSize={{ minRows: 3, maxRows: 5 }}
                  />

                </Container>
                <Col className="text-center">


                </Col>

              </Container>

            </Container>


          </Modal.Body>
          <Modal.Footer>

            <Container className="container-fluid">
              <div className="d-flex justify-content-center">

                <button className=" btn btn-danger shadow " onClick={() => { setShowInformacion(false) }} >

                  {" "}
                  Cancelar
                  {" "}
                  <FontAwesomeIcon icon={faCircleXmark} />
                </button>



              </div>
            </Container>

          </Modal.Footer>
        </Modal>



      </ConfigProvider >
    </>
  )
}